export const FormSamplesCustomControlPageInfo = () => {
    return (
        <>
            You can create your own custom control to use in the form.<br />
            The example belows shows a custom Rock Paper Scissors input.<br />
            Your custom control has to have the following props in order to function:
            <ul>
                <li>value</li>
                <li>onChange</li>
                <li>onBlur</li>
            </ul>
            You can take advantage of the following props as well to show errors or perform other behaviour
            <ul>
                <li>label</li>
                <li>showError</li>
                <li>errorMessage</li>
                <li>onError</li>
                <li>disable</li>
                <li>required</li>
            </ul>            
            You can use the ControlProps interface or the ExtendedControlProps interface for your props (like this example does).
        </>
    )
}
